import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Facsimile } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesParatesto, validationSchemaParatesto } from "./ParatestoCommon"
import ParatestoForm from "./ParatestoForm"
import { useMemo } from "react"
import { useParatestoCreate } from "../../hooks/paratesti"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function ParatestoCreate() {
  const createParatesto = useParatestoCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Paratesti", href: "/edizioni/paratesti" }, { label: "Creazione Paratesto" }])

  const initialValues = useMemo(() => initialValuesParatesto(), [])
  const validationSchema = useMemo(() => validationSchemaParatesto(true), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo paratesto</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createParatesto.mutateAsync(values as Facsimile).then((paratesto) => {
                navigate(`/edizioni/paratesti/${paratesto.id}`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ParatestoForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/paratesti" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
